export const API_ADMIN_GET_ALL_TUBELIBRARY = 'API_ADMIN_GET_ALL_TUBELIBRARY';
export const API_ADMIN_GET_ALL_TUBELIBRARY_SUCCESS = 'API_ADMIN_GET_ALL_TUBELIBRARY_SUCCESS';
export const API_ADMIN_GET_ALL_TUBELIBRARY_FAIL = 'API_ADMIN_GET_ALL_TUBELIBRARY_FAIL';

export const API_GET_ALL_TUBELIBRARY = 'API_GET_ALL_TUBELIBRARY';
export const API_GET_ALL_TUBELIBRARY_SUCCESS = 'API_GET_ALL_TUBELIBRARY_SUCCESS';
export const API_GET_ALL_TUBELIBRARY_FAIL = 'API_GET_ALL_TUBELIBRARY_FAIL';

export const API_ADMIN_GET_TUBELIBRARY = 'API_ADMIN_GET_TUBELIBRARY';
export const API_ADMIN_GET_TUBELIBRARY_SUCCESS = 'API_ADMIN_GET_TUBELIBRARY_SUCCESS';
export const API_ADMIN_GET_TUBELIBRARY_FAIL = 'API_ADMIN_GET_TUBELIBRARY_FAIL';

export const ADMIN_INIT_NEW_TUBELIBRARY = 'ADMIN_INIT_NEW_TUBELIBRARY'
export const ADMIN_RESET_FOCUS_TUBELIBRARY = 'ADMIN_RESET_TUBELIBRARY'
export const ADMIN_UPDATE_FOCUS_PHOTO_TUBELIBRARY = 'ADMIN_UPDATE_FOCUS_PHOTO_TUBELIBRARY'